import React from "react";

type RealEstateResultCardProps = {
  label: string;
  value: string;
  tone?: "default" | "good" | "warn";
  subvalue?: string;
};

export function RealEstateResultCard({
  label,
  value,
  tone = "default",
  subvalue,
}: RealEstateResultCardProps): React.ReactElement {
  return (
    <article className={`re-result-card re-result-card-${tone}`}>
      <div className="re-result-label">{label}</div>
      <div className="re-result-value">{value}</div>
      {subvalue ? <div className="re-result-subvalue">{subvalue}</div> : null}
    </article>
  );
}
